export default "__VITE_ASSET__86wzuMaN__"